import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loader } from 'semantic-ui-react';
import Const from '../../config/const';
import { loadFavoriteWalls, addWallToCanvas } from '../../actions/favorite_walls';
import { closePanel } from '../../actions/panel';
import FavoriteWallCard from './favorite_wall_card';
import * as classes from './styles.module.scss';

const FindFavoriteWalls = ({
  walls,
  loading,
  loaded,
  pinned,
  loadFavoriteWalls: loadWalls,
  addWallToCanvas: addWall,
  closePanel: closePanelAction
}) => {
  useEffect(() => {
    loadWalls();
  }, [loadWalls]);

  const handleAdd = useCallback((id) => {
    addWall(id);
    if (!pinned) {
      closePanelAction(Const.panelKinds.works);
    }
  }, [addWall, pinned, closePanelAction]);

  if (!loaded && loading) {
    return (
      <div className={ classes.loaderWrap }>
        <Loader active inline />
      </div>
    );
  }

  if (!loaded) {
    return null;
  }

  if (walls.length === 0) {
    return null;
  }

  return (
    <>
      <h3 className={ classes.sectionHeading }>Walls</h3>
      <div className={ classes.wallsGrid }>
        { walls.map((w) => (
          <FavoriteWallCard
            key={ w.id }
            id={ w.id }
            name={ w.name }
            imageUrl={ w.imageUrl }
            itemCount={ w.itemCount }
            onAdd={ handleAdd }
          />
        )) }
      </div>
    </>
  );
};

FindFavoriteWalls.propTypes = {
  walls: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string,
    itemCount: PropTypes.number.isRequired
  })).isRequired,
  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
  pinned: PropTypes.bool.isRequired,
  loadFavoriteWalls: PropTypes.func.isRequired,
  addWallToCanvas: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired
};

const mapStateToProps = ({ favoriteWalls, pin }) => ({
  ...favoriteWalls,
  ...pin
});

export default connect(mapStateToProps, {
  loadFavoriteWalls,
  addWallToCanvas,
  closePanel
})(FindFavoriteWalls);
